import {axiosGet} from "../../../../common/Helper/AxiosHelper";
import {QUESTION} from "../../../../tenant/Config/ApiUrl";

const state = {
    question: {},
}

const getters = {
    getQuestionDetails: state => {
        return state.question
    }
};

const actions = {
    getQuestionDetails({commit, state}, questionId) {
        commit('SET_LOADER', true)
        axiosGet(`${QUESTION}/${questionId}`).then(({data}) => {
            commit('QUESTION_DETAILS_DATA', data)
        }).finally(() => commit('SET_LOADER', false))
    },
}

const mutations = {
    QUESTION_DETAILS_DATA(state, data) {
        state.question = data;
    },
}

export default {
    state,
    actions,
    getters,
    mutations
}
